export default function () {
    function setAdsourceCookie(name, value, expirity) {
        document.cookie = name + '=' + value + '; expires=' + expirity + ';';
    }

    function validateAdsourceCookie(name) {
        const value = '; ' + document.cookie;
        const parts = value.split('; ' + name + '=');
        if (parts.length == 2) {
            return parts.pop().split(';').shift();
        } else {
            return false;
        }
    }

    function prepareCookieExpirity(days) {
        const cookieDate = new Date;
        cookieDate.setTime(cookieDate.getTime() + (days * 24 * 60 * 60 * 1000));
        return cookieDate.toGMTString();
    }

    function getUrlParameter(parameterName) {
        /* eslint-disable no-useless-escape */
        var results = new RegExp('[\?&]' + parameterName + '=([^&#]*)').exec(window.location.href); 
        /* eslint-enable no-useless-escape */

        if (results) {
            return results[1];
        } else {
            return false;
        }
    }

    const cookieStatus = validateAdsourceCookie('adsource');

    if (!cookieStatus) {
        const adsource = getUrlParameter('adsource');
        if(adsource) {
            setAdsourceCookie('adsource', adsource, prepareCookieExpirity(9999));
        }
    }

}



// WEBPACK FOOTER //
// ../Resources/Private/JavaScript/features/adsource.js